import { useCallback, useState } from 'react';
import styles from './Accordion.module.css';
import Image from 'next/image';
import clsx from 'clsx';

type AccordionProps = {
  title: string;
  content: string;
  index: number;
};

export default function Accordion({ index, title, content }: AccordionProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  const toggleAccordion = useCallback(
    () => setIsExpanded(!isExpanded),
    [isExpanded]
  );
  const iconToShow = isExpanded ? 'minus-black' : 'plus-black';

  return (
    <>
      <button
        onClick={toggleAccordion}
        className={clsx(styles.question, "font-light tracking-normal py-3")}
        tabIndex={0}
        aria-controls={`faq_${index}accordion`}
        id={`faq_${index}_header-accordion`}
        aria-expanded={isExpanded}
      >
        {title}
        <div>
          <Image
            alt={isExpanded ? 'hide' : 'show'}
            src={`/icons/${iconToShow}.svg`}
            width={12}
            height={12}
          />
        </div>
      </button>
      <div
        className={clsx(styles.answer, { [styles.show]: isExpanded })}
        id={`faq_${index}_panel`}
        role="region"
        aria-labelledby={`faq_${index}_header`}
      >
        {content}
      </div>
    </>
  );
}
